import React from 'react';
import FeedBacks from '../../../common/feedback/index'

export default function StoreFeedBacks(){

  return <FeedBacks isStore={true}/>
}
